import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { NumericFormat } from "react-number-format";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../Base/Components/Card/Card";
import { useForm } from "../../../../Base/Hooks/useForm";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";

// ------------------- CONSULTAS A LA API---------------------------
import { getBuyers, getCustomers } from "../../../../API/Clientes/ClientesRequests";
import { getUsuarios } from "../../../../API/IT/Usuarios/UsersRequests";
import { getTerminos } from "../../../../API/Compras/Otros/TerminosRequests";
import { EditarCotizacion, EditarCotizacionSencilla, getAdditional, getDetallePorId, getDetallePorQuotation, getEncabezadoPorId, getEncabezadoPorQuotation, GuardarCotizacion, GuardarCotizacionSencilla, ObtenerSiguienteNoCotizacion } from "../../../../API/Ventas/Cotizaciones/CotizacionesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import EncabezadoCotizacion from "./EncabezadoCotizacion";


const CotizacionesCRUD1 = ({
  showDialog,
  setShowDialog,
  setSelectedEnc,
  selectedEnc,
  habilitar,
  setHabilitar,
  getInfo
}) => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [paymentTerm, setPaymentTerm] = useState([]);
  const [shipmentTerm, setShipmentTerm] = useState([]);
  const [costosAdicionales, setCostosAdicionales] = useState([]);
  const [costosOtros, setCostosOtros] = useState([]);
  const [totalAdicional, setTotalAdicional] = useState(0);
  const [totalOtros, setTotalOtros] = useState(0);
  const [dialogDetails, setDialogDetails] = useState(false);
  const [total, setTotal]= useState(0);

  const initialValues = {
    IdQuotation: -1,
    Date: new Date(),
    Comment: '',
  };

  const origen = [
    { IdOrigin: 1, Origin: "CAFTA" },   
    { IdOrigin: 2, Origin: "NO CAFTA" },   
  ]  

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getInfo2 = async (selectedEnc) => {
    setLoading(true);

    const correlativo = await ObtenerSiguienteNoCotizacion();

    const clientesTempo = await getCustomers();
    setClientes(clientesTempo);

    const agentesTempo = await getUsuarios();


    setAgentes(agentesTempo.filter((i) => i.IdRol === 6 && i.IdStatus === 82));  

    const r = await getBuyers()
    setBuyers(r)

    const paymentTermTempo = await getTerminos();

    const paymentTerms = paymentTermTempo
    .filter((i) => i.IdTypeTerm === 1) 
    .map((term) => ({
      IdPaymentTerm: term.IdTerm,
      TermNamePayment: term.TermName,
      TermValue: term.TermValue, 
    }));
    
    const shipmentTerms = paymentTermTempo
    .filter((i) => i.IdTypeTerm === 2) 
    .map((term) => ({
      IdShitmentTerm: term.IdTerm,
      TermNameShitment: term.TermName,
      TermValue: term.TermValue, 
    }));
    
    setPaymentTerm(paymentTerms);
    setShipmentTerm(shipmentTerms);

    if(selectedEnc?.length <= 0 || !selectedEnc){
      const d = {
        ...values,
        Date: new Date(),
        IdQuotation: -100,
        Quotation: correlativo[0]?.NoQuotation,
      };
      setValues(d);
      setDetalles([])
      setHabilitar(true);
    }else{
      const encabezadoTempo = await getEncabezadoPorId(selectedEnc?.IdQuotation)
      const detallesTempo = await getDetallePorId(selectedEnc?.IdQuotation)
      
      const addTempo = await getAdditional();
      let newDetalles = [];
      
      detallesTempo.forEach((detalle) => {
        const { IdQuotationDetail } = detalle;
 
        const costosAdicionales = addTempo.filter(
          (item) => item.IdTipo === 1 && item.IdQuotationDetail === IdQuotationDetail
        );
      
        const costosOtros = addTempo.filter(
          (item) => item.IdTipo === 2 && item.IdQuotationDetail === IdQuotationDetail
        );
      
        const detalleConAdicionales = {
          ...detalle,
          Adicionales: [...costosAdicionales, ...costosOtros],
        };
      
        newDetalles.push(detalleConAdicionales);
      });

      
      setDetalles(newDetalles);
      if(encabezadoTempo.length > 0){
        const [encabezado] = encabezadoTempo

        const n ={
          ...encabezado,
          Date: new Date(encabezado?.Date),
        }
        setValues(n)
        setHabilitar(false);
      }
    }



    setLoading(false);
  };

  const obtener = async (Quotation) => {
    setLoading(true)

    let encabezadoTempo = await getEncabezadoPorQuotation(Quotation)
    let detallesTempo = await getDetallePorQuotation(Quotation)
    const addTempo = await getAdditional();
    let newDetalles = [];


    if(detallesTempo?.length > 0){
      detallesTempo.forEach((detalle) => {
        const { IdQuotationDetail } = detalle;
  
        const costosAdicionales = addTempo.filter(
          (item) => item.IdTipo === 1 && item.IdQuotationDetail === IdQuotationDetail
        );
      
        const costosOtros = addTempo.filter(
          (item) => item.IdTipo === 2 && item.IdQuotationDetail === IdQuotationDetail
        );
      
        const detalleConAdicionales = {
          ...detalle,
          Adicionales: [...costosAdicionales, ...costosOtros],
        };
      
        newDetalles.push(detalleConAdicionales);
      });
    }

    
    setDetalles(newDetalles);
    if(encabezadoTempo?.length > 0){
      const [encabezado] = encabezadoTempo

      const n ={
        ...encabezado,
        Date: new Date(encabezado?.Date),
      }
      setValues(n)
      setHabilitar(false);
    }

    setLoading(false)
  }

  const guardarCotizacion = async (newRowData = null) => {

    const Encabezado = {
      IdQuotation: values?.IdQuotation,
      Date: new Date(values?.Date),
      IdCustomer: values?.CustomerName?.IdCustomer || values?.IdCustomer,
      IdBuyer: values?.CompanyName?.IdDCustomer ||  values?.IdBuyer,
      IdSalesAgent: values?.UserName?.idUser || values?.IdSalesAgent ,
      Comment: values?.Comment,
      IdPaymentTerm:values?.TermNamePayment?.IdPaymentTerm || values?.IdPaymentTerm ,
      IdShitmentTerm: values?.TermNameShitment?.IdShitmentTerm || values?.IdShitmentTerm,
      IdUserCreate: userAuth?.idUser,
      IdUserEdit: userAuth?.idUser,
    }

    let Detalles

    if(newRowData){
      console.log("IF")
      Detalles = newRowData.map((detalle) => ({
        ...detalle[0],
        IdQuotationDetail: detalle.IdQuotationDetail,
        IdStyleCategory: detalle?.IdStyleCategory,
        IdYarnTitle: detalle?.IdYarnTitle,
        IdFabricStyle: detalle?.IdFabricStyle,
        IdDyeType: detalle?.IdDyeType,
        IdDensity: detalle?.IdDensity,
        KnitCost: detalle?.KnitCost,
        DyeCost: detalle?.DyeCost,
        AdditionalCost: detalle?.AdditionalCost,
        OtherCost: detalle?.OtherCost,
        Comment: detalle?.Comment,
        IdUnit: detalle?.IdUnit,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
        Adicionales: detalle?.Adicionales,
        Cantidad: detalle?.Cantidad,
        Total: detalle?.Total
      }));
    }else{
      Detalles = detalles.map((detalle) => ({
        ...detalle[0],
        IdQuotationDetail: detalle.IdQuotationDetail,
        IdStyleCategory: detalle?.IdStyleCategory,
        IdYarnTitle: detalle?.IdYarnTitle,
        IdFabricStyle: detalle?.IdFabricStyle,
        IdDyeType: detalle?.IdDyeType,
        IdDensity: detalle?.IdDensity,
        KnitCost: detalle?.KnitCost,
        DyeCost: detalle?.DyeCost,
        AdditionalCost: detalle?.AdditionalCost,
        OtherCost: detalle?.OtherCost,
        Comment: detalle?.Comment,
        IdUnit: detalle?.IdUnit,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
        Adicionales: detalle?.Adicionales,
        Cantidad: detalle?.Cantidad,
        Total: detalle?.Total
      }));
    }

    if(Detalles.length <= 0){
      toastShow(toast, "error", "Error", 'Agrega al menos un detalle.');
      return
    }

    let Det = detalles.filter((detalle) => detalle.Cantidad > 0);

    if (Det.length !== detalles.length) {
      toastShow(toast, "error", "Error", 'Las cantidades de los detalles deben ser mayor a 0.');
      return
    } 
    
    setLoading(true)

    if(values?.IdQuotation > 0){
      const respuesta = await EditarCotizacion(Encabezado, Detalles)
      if (respuesta[0]?.ESTADO !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Guardada", respuesta[0].MENSAJE);
        getInfo()
        setTimeout(() => {
          getInfo2(respuesta[0]) 
          setSelected([])
          setSelectedEnc(respuesta[0])
        }, 1000);
        setLoading(false);
      } else {
        toastShow( toast, "error", "Error", respuesta[0].MENSAJE);
        setLoading(false);
      }
    }else{
      const respuesta = await GuardarCotizacion(Encabezado, Detalles)
      if (respuesta[0]?.ESTADO !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Guardada", respuesta[0].MENSAJE);
        getInfo()
        setTimeout(() => {
          getInfo2(respuesta[0]) 
          setSelected([])
          setSelectedEnc(respuesta[0])
        }, 1000);
        setLoading(false);
      } else {
        toastShow( toast, "error", "Error", respuesta[0].MENSAJE);
        setLoading(false);
      }
    }
  };

  const guardarCotizacion1 = async () => {

    const Encabezado = {
      IdQuotation: values?.IdQuotation,
      Date: new Date(values?.Date),
      IdCustomer: values?.CustomerName?.IdCustomer || values?.IdCustomer,
      IdBuyer: values?.CompanyName?.IdDCustomer ||  values?.IdBuyer,
      IdSalesAgent: values?.UserName?.idUser || values?.IdSalesAgent ,
      Comment: values?.Comment,
      IdPaymentTerm:values?.TermNamePayment?.IdPaymentTerm || values?.IdPaymentTerm ,
      IdShitmentTerm: values?.TermNameShitment?.IdShitmentTerm || values?.IdShitmentTerm,
      IdUserCreate: userAuth?.idUser,
      IdUserEdit: userAuth?.idUser,
      IdOrigin: values?.Origin?.IdOrigin || values?.IdOrigin,
      Origin: values?.Origin?.Origin || values?.Origin,
    }


    const Detalles = detalles.map((detalle) => ({
      ...detalle[0],
      IdQuotationDetail: detalle.IdQuotationDetail,
      FabricType: detalle?.FabricType,
      FabricContent: detalle?.FabricContent,
      YarnSpec: detalle?.YarnSpec,
      IdOrigin: detalle?.IdOrigin,
      Origin: detalle?.Origin,
      WeightGSM: detalle?.WeightGSM,
      CuttableGSM: detalle?.CuttableGSM,
      FullWidth: detalle?.FullWidth,
      Grade: detalle?.Grade,
      Process: detalle?.Process,
      CifPriceKG: detalle?.CifPriceKG,
      CifPriceLB: detalle?.CifPriceLB,
      CifPriceYD: detalle?.CifPriceYD,
      IdUserCreate: userAuth?.idUser,
      IdUserEdit: userAuth?.idUser,
    }));
    
    if (Detalles.length <= 0) {
      toastShow(toast, "error", "Error", "Agrega al menos un detalle.");
      return;
    }

    const camposTexto = ["FabricType", "FabricContent", "YarnSpec", "Grade"];
  
    const errorCampoTexto = Detalles.find((detalle) => 
      camposTexto.some((campo) => !detalle[campo] || detalle[campo].trim() === "")
    );
    
    if (errorCampoTexto) {
      const campoVacio = camposTexto.find((campo) => !errorCampoTexto[campo] || errorCampoTexto[campo].trim() === "");
      toastShow(toast, "error", "Error", `${campoVacio} es requerido.`);
      return;
    }

    // const errorOrigin = Detalles.find((detalle) => !detalle.IdOrigin || !detalle.Origin || detalle.Origin.trim() === "");

    // if (errorOrigin) {
    //   toastShow(toast, "error", "Error", "El campo Origen es requerido.");
    //   return;
    // }
    const camposNumericos = ["WeightGSM", "CuttableGSM", "FullWidth", "CifPriceKG", "CifPriceLB", "CifPriceYD"];

    const errorCampoNumerico = Detalles.find((detalle) => 
      camposNumericos.some((campo) => detalle[campo] === undefined || detalle[campo] <= 0)
    );
    
    if (errorCampoNumerico) {
      toastShow(toast, "error", "Error", "Los valores ingresados en cada detalle deben ser mayores a 0.");
      return;
    }
      
    setLoading(true)

    if(values?.IdQuotation > 0){
      const respuesta = await EditarCotizacionSencilla(Encabezado, Detalles)
      if (respuesta[0]?.ESTADO !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Guardada", respuesta[0].MENSAJE);
        getInfo()
        setTimeout(() => {
          getInfo2(respuesta[0]) 
          setSelected([])
          setSelectedEnc(respuesta[0])
        }, 1000);
        setLoading(false);
      } else {
        toastShow( toast, "error", "Error", respuesta[0].MENSAJE);
        setLoading(false);
      }
    }else{
      const respuesta = await GuardarCotizacionSencilla(Encabezado, Detalles)
      if (respuesta[0]?.ESTADO !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Guardada", respuesta[0].MENSAJE);
        getInfo()
        setTimeout(() => {
          getInfo2(respuesta[0]) 
          setSelected([])
          setSelectedEnc(respuesta[0])
        }, 1000);
        setLoading(false);
      } else {
        toastShow( toast, "error", "Error", respuesta[0].MENSAJE);
        setLoading(false);
      }
    }
  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];

    let IdDet = -(detalles?.length + 1);
    const newData = {
      IdQuotationDetail: IdDet,
      Date: new Date(),
      FabricType: "",
      FabricContent: "",
      YarnSpec: "",
      Origin: "",
      WeightGSM: 0,
      CuttableGSM: 0,
      FullWidth: 0,
      Grade: '',
      //COSTOS
      CifPriceKG: 0,
      CifPriceLB: 0,
      CifPriceYD: 0,
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const changeFabricType = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdQuotationDetail === data?.IdQuotationDetail);
    let newDetail = [...detalles];
    if (column.field === "FabricType") {
      newDetail[index].FabricType = data.FabricType;
    }
    setDetalles(newDetail);
  };

  const changeFabricContent = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdQuotationDetail === data?.IdQuotationDetail);
    let newDetail = [...detalles];
    if (column.field === "FabricContent") {
      newDetail[index].FabricContent = data.FabricContent;
    }
    setDetalles(newDetail);
  };

  const changeYarnSpec= ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdQuotationDetail === data?.IdQuotationDetail);
    let newDetail = [...detalles];
    if (column.field === "YarnSpec") {
      newDetail[index].YarnSpec = data.YarnSpec;
    }
    setDetalles(newDetail);
  };

  const changeGrade= ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdQuotationDetail === data?.IdQuotationDetail);
    let newDetail = [...detalles];
    if (column.field === "Grade") {
      newDetail[index].Grade = data.Grade;
    }
    setDetalles(newDetail);
  };

  const changeProcess = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail?.IdQuotationDetail === data?.IdQuotationDetail);
    let newDetail = [...detalles];
    if (column.field === "Process") {
      newDetail[index].Process = data.Process;
    }
    setDetalles(newDetail);
  };

  const calcularCantidad = (value, datosD, columna) => {
    let valor = value === undefined ? 0 : value
    let detalle

    if(columna === 1){
      handleChange(valor, "WeightGSM")
      detalle = datosD.data
      detalle.WeightGSM = valor
    }else if(columna === 2){
      handleChange(valor, "CuttableGSM")
      detalle = datosD.data
      detalle.CuttableGSM = valor
    }else if(columna === 3){
      handleChange(valor, "FullWidth")
      detalle = datosD.data
      detalle.FullWidth = valor
    }else if(columna === 4){
      handleChange(valor, "CifPriceKG")
      detalle = datosD.data
      detalle.CifPriceKG = valor
      detalle.CifPriceLB = valor / 2.20462

      // GM_YD = (detalle?.WeightGSM /33.9) * ( ((28.345*detalle?.FullWidth) / 36 /1000) )
      // detalle.CifPriceYD = GM_YD * detalle?.CifPriceKG

    }else if(columna === 5){
      handleChange(valor, "CifPriceLB")
      detalle = datosD.data
      detalle.CifPriceLB = valor
    }else if(columna === 6){
      handleChange(valor, "CifPriceYD")
      detalle = datosD.data
      detalle.CifPriceYD = valor
    }

    if (detalle.WeightGSM > 0 && detalle.FullWidth > 0 && detalle.CifPriceKG > 0) {
      let GM_YD = (detalle.WeightGSM / 33.9) * ((28.345 * detalle.FullWidth) / 36 / 1000);
      detalle.CifPriceYD = GM_YD * detalle.CifPriceKG;
    }
  
        
    let tempo = detalles
    const index = tempo.findIndex(detail => detail?.IdQuotationDetail === detalle?.IdQuotationDetail)
    tempo[index] = detalle
    setDetalles(tempo)
  }

  const InputWeightGSM = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.WeightGSM}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 1)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const InputCuttableGSM = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.CuttableGSM}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 2)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const InputFullWidth = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.FullWidth}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 3)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const InputCifPriceKG = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.CifPriceKG}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 4)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const InputCifPriceLB = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.InputCifPriceLB}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 5)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const InputCifPriceYD = ({ datosD }) => {
    return (
      <div >
        <NumericFormat
          value={datosD.data.InputCifPriceYD}
          onValueChange={(values, sourceInfo) => {calcularCantidad(values.floatValue, datosD, 6)}}
          allowLeadingZeros
          thousandSeparator=","
          disabled={!habilitar}
        />
      </div>
    )
  }

  const changeWeightGSM = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdQuotationDetail === data.IdQuotationDetail);
    let newDetail = [...detalles];

    if (column.field === "WeightGSM") {
      newDetail[index].WeightGSM = data.WeightGSM;
      setDetalles(newDetail);
    }
  };

  const changeCuttableGSM = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdQuotationDetail === data.IdQuotationDetail);
    let newDetail = [...detalles];

    if (column.field === "CuttableGSM") {
      newDetail[index].CuttableGSM = data.CuttableGSM;
      setDetalles(newDetail);
    }
  };

  const changeFull = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdQuotationDetail === data.IdQuotationDetail);
    let newDetail = [...detalles];

    if (column.field === "FullWidth") {
      newDetail[index].FullWidth = data.FullWidth;
      setDetalles(newDetail);
    }
  };

  const changeValue = ({ data, column }, field, columnIndex) => {
    const index = detalles.findIndex((detail) => detail.IdQuotationDetail === data.IdQuotationDetail);
    let newDetail = [...detalles];
  
    newDetail[index][field] = data[field];
  
    if (columnIndex === 4) {
      newDetail[index].CifPriceLB = data.CifPriceKG / 2.20462;
    }
  
    if (newDetail[index].WeightGSM > 0 && newDetail[index].FullWidth > 0 && newDetail[index].CifPriceKG > 0) {
      let GM_YD = (newDetail[index].WeightGSM / 33.9) * ((28.345 * newDetail[index].FullWidth) / 36 / 1000);
      newDetail[index].CifPriceYD = GM_YD * newDetail[index].CifPriceKG;
    }
    
    setDetalles(newDetail);
  };

  

  const columns = [
    {
      field: "IdQuotationDetail",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "Date",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      frozen: true,
      Format: "DateTime",
    },
    {
      header: 'Fabric Type',
      headerEn: 'Fabric Type',
      field: 'FabricType',
      className: 'large',
      editable: habilitar,
      onChange: (data) => changeFabricType(data),
    },
    {
      header: 'Fabric Content',
      headerEn: 'Fabric Content',
      field: 'FabricContent',
      className: 'large',
      editable: habilitar,
      onChange: (data) => changeFabricContent(data),
    },
    {
      header: 'Yarn Spec',
      headerEn: 'Yarn Spec',
      field: 'YarnSpec',
      className: 'XXlarge',      
      editable: habilitar,
      onChange: (data) => changeYarnSpec(data),
      flex: 1,
      minWidth: 500,
    },
    {
      header: 'Weight GSM',
      headerEn: 'Weight GSM',
      field: 'WeightGSM',
      onChange: (data) => changeValue(data, 'WeightGSM', 1),
      editable: habilitar,
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Cuttable GSM',
      headerEn: 'Cuttable GSM',
      field: 'CuttableGSM',
      onChange: (data) => changeValue(data, 'CuttableGSM', 2),
      editable: habilitar,
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Full Width',
      headerEn: 'Full Width',
      field: 'FullWidth',
      onChange: (data) => changeValue(data, 'FullWidth', 3),
      editable: habilitar,          
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
    },
    {
      header: 'Grade',
      headerEn: 'Grade',
      field: 'Grade',
      className:'Xsmall',
      editable: habilitar,
      onChange: (data) => changeGrade(data),
    },
    {
      header: 'Proceso',
      headerEn: 'Process',
      field: 'Process',
      className:'small',
      editable: habilitar,
      onChange: (data) => changeProcess(data),
    },
    {
      headerName: 'CIF PRICE $',
      headerNameEn: 'CIF PRICE $',
      children: [
        {
          field: 'CifPriceKG',
          header: 'Kilogramo',
          headerEn: 'Kilogram',
          frozen: true,
          alignFrozen: 'right',
          onChange: (data) => changeValue(data, 'CifPriceKG', 4),
          editable: habilitar,
          className: 'Xsmall',
          Format: 'Currency',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceLB',
          header: 'Libra',
          headerEn: 'Pound',
          onChange: (data) => changeValue(data, 'CifPriceLB', 5),
          editable: habilitar,
          className: 'Xsmall',
          frozen: true,
          alignFrozen: 'right',
          Format: 'Currency',
          Sumary: 'sum',
        },
        {
          field: 'CifPriceYD',
          header: 'Yarda',
          headerEn: 'Yard',
          onChange: (data) => changeValue(data, 'CifPriceYD', 6),
          editable: habilitar,
          className: 'Xsmall',
          frozen: true,
          alignFrozen: 'right',
          Format: 'Currency',
          Sumary: 'sum',
        },
        // {
        //   field: 'CifPriceKG',
        //   header: 'Kilogramo',
        //   headerEn: 'Kilogram',      
        //   frozen: true,
        //   alignFrozen: 'right',
        //   cellEditor: (data) => <InputCifPriceKG datosD={data}/>,
        //   editable: habilitar,
        //   className: 'Xsmall',
        //   Format: 'Currency',
        //   Sumary: 'sum',
        // },
        // {
        //   field: 'CifPriceLB',
        //   header: 'Libra',
        //   headerEn: 'Pound',
        //   className: 'Xsmall',
        //   frozen: true,
        //   cellEditor: (data) => <InputCifPriceLB datosD={data}/>,
        //   editable: habilitar,
        //   alignFrozen: 'right',
        //   Format: 'Currency',
        //   Sumary: 'sum',
        // },
        // {
        //   field: 'CifPriceYD',
        //   header: 'Yarda',
        //   headerEn: 'Yard',
        //   cellEditor: (data) => <InputCifPriceYD datosD={data}/>,
        //   editable: habilitar,
        //   className: 'Xsmall',
        //   frozen: true,
        //   alignFrozen: 'right',
        //   Format: 'Currency',
        //   Sumary: 'sum',
        // },
      ]
    },    
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
  };

  const cerrarConfirmacion = () => {
    if (habilitar && values?.IdQuotation > 0) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(false)
          setSelectedEnc([])
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(false)
      setSelectedEnc([])
      setHabilitar(true);
    }
  };

  const duplicarCotizacion = async(encabezado, detalles) => {
    if(encabezado?.IdQuotation > 0){
      setLoading(true)
      const Quotation = await ObtenerSiguienteNoCotizacion()

      setValues({
        ...values,
        Date: new Date(),
        IdQuotation: -100,
        Quotation: Quotation[0]?.NoQuotation
      })

      const nuevosDetalles = detalles.map((det) => ({
        ...det,
        IdQuotationDetail: (det?.IdQuotationDetail) * -1,
        Adicionales: det?.Adicionales?.map(adicional => ({
          ...adicional,
          IdAdditional: -(adicional?.IdAdditional)
        })),
      }))


      // console.log(costosOtros)
      // console.log(costosAdicionales)

      setHabilitar(true)
      setDetalles(nuevosDetalles)
      setLoading(false)
    }else{
      toastShow(toast, "error", "Error", 'Guarde la cotización antes de duplicarla.');
    }
  }


  useEffect(() => {
    getInfo2(selectedEnc);
  }, [selectedEnc]);

  return (
    <Dialog
      visible={showDialog}
      onHide={() => {
        // setShowDialog(false)
        // setSelectedEnc([])
        cerrarConfirmacion()
      }}
      // maximized={true}
      maximizable={true}
      closeOnEscape={false}
      header={getLabel(baseLang, "cotizacion", config.language)}
      style={{width: "90%", height: "90%"}}
    >
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoCotizacion
        values={values}
        setValues={setValues}
        handleInputChange={handleInputChange}
        toast={toast}
        habilitar={habilitar}
        setHabilitar={setHabilitar}
        clientes={clientes}
        buyers={buyers}
        setBuyers={setBuyers}
        agentes={agentes}
        paymentTerm={paymentTerm}
        shipmentTerm={shipmentTerm}
        costosAdicionales={costosAdicionales}
        setCostosAdicionales={setCostosAdicionales}
        costosOtros={costosOtros}
        setCostosOtros={setCostosOtros}
        totalAdicional={totalAdicional}
        setTotalAdicional={setTotalAdicional}
        totalOtros={totalOtros}
        setTotalOtros={setTotalOtros}
        agregarNuevaFila={agregarNuevaFila}
        guardarCotizacion={guardarCotizacion}
        dialogDetails={dialogDetails}
        setDialogDetails={setDialogDetails}
        selected={selected}
        setSelected={setSelected}
        getInfo={getInfo2}
        detalles={detalles}
        setDetalles={setDetalles}
        selectedEnc={selectedEnc}
        setTotal={setTotal}
        total={total}
        obtener={obtener}
        duplicarCotizacion={duplicarCotizacion}
        guardarCotizacion1={guardarCotizacion1}
        origen={origen}
      />

      <Card
        contenido={
          <div style={{ height: "56vh"}}>
            <AgGrid table={table} />
          </div>
        }
      />
    </Dialog>
  );
};

export default CotizacionesCRUD1;
